/* @flow */
import gql from 'graphql-tag';
import * as React from 'react';
import Row from 'components/Row';
import Link from 'components/Link';
import Text from 'components/Text';
import { graphql } from 'react-apollo';
import Image from 'components/Image';
import Dialog from 'components/Dialog';
import Heading from 'components/Heading';
import BoxBody from 'components/BoxBody';
import memoize from 'lodash/memoize';

type UpsellModalProps = {
  integration: *,
  mutate: Function,
  organizationUUID: string,
  onRequestHide: Function,
};

const once = memoize(
  (cb, ...args: string[]) => cb(...args),
  (cb, ...args: string[]) => args.join('_')
);

class AdminIntegratedToolsUpsellModal extends React.Component<UpsellModalProps, {}> {
  componentDidMount() {
    once(
      (orgUUID, providerKey) => this.props.mutate({ variables: { orgUUID, providerKey } }),
      this.props.organizationUUID,
      this.props.integration.providerKey
    );
  }

  render() {
    return (
      <Dialog onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <Row>
            <Image
              style={{ width: '250px' }}
              src={require('assets/images/two_people_talking_on_phone.png')}
            />
          </Row>
          <Heading>We’re excited to get you set up!</Heading>
          <Row>
            <Text size="small" color="graphite">
              Reach out to your Remind account rep to enable this feature on your account.
            </Text>
          </Row>
          <Link onClick={this.props.onRequestHide}>
            <Text weight="semibold">Skip for now</Text>
          </Link>
        </BoxBody>
      </Dialog>
    );
  }
}

const withMutation = graphql(
  gql`
    mutation foo($orgUUID: String!, $providerKey: String!) {
      adminPossibleIntegrationUpsellRequest(orgUUID: $orgUUID, providerKey: $providerKey)
    }
  `
);

export default withMutation(AdminIntegratedToolsUpsellModal);
